import { api } from "./client";

export type EmailTemplateRow = {
  id: string;
  name: string;
  subject: string;
  template_location: string;
  description: string | null;
  active: boolean;
  created_at: string | null;
  updated_at: string | null;
};

export type EmailTemplateCreate = {
  name: string;
  subject: string;
  template_location: string;
  description?: string | null;
  active?: boolean;
};

export type EmailTemplatePatch = Partial<{
  subject: string;
  description: string | null;
  active: boolean;
  template_location: string;
}>;

export const EmailTemplatesApi = {
  list() {
    return api
      .get<{ templates: EmailTemplateRow[] }>("/email-templates")
      .then((r) => r.data.templates);
  },
  get(id: string) {
    return api
      .get<EmailTemplateRow>(`/email-templates/${id}`)
      .then((r) => r.data);
  },
  getHtml(id: string) {
    return api
      .get<{ html: string }>(`/email-templates/${id}/html`)
      .then((r) => r.data.html);
  },
  update(id: string, patch: EmailTemplatePatch) {
    return api
      .patch<EmailTemplateRow>(`/email-templates/${id}`, patch)
      .then((r) => r.data);
  },
  getUploadUrl(contentType: string) {
    return api
      .post<{ uploadUrl: string; key: string; expiresIn: number }>(
        "/email-templates/upload-url",
        { contentType },
      )
      .then((r) => r.data);
  },
  create(body: EmailTemplateCreate) {
    return api
      .post<EmailTemplateRow>("/email-templates", body)
      .then((r) => r.data);
  },
  remove(id: string) {
    return api
      .delete<{ deleted: string }>(`/email-templates/${id}`)
      .then((r) => r.data);
  },
};
